function validatePhoneNumber(tel1, tel2, tel3) {
    // Check if all parameters are numbers and have a maximum length of 5
    if (!/^\d{1,5}$/.test(tel1) || !/^\d{1,5}$/.test(tel2) || !/^\d{1,5}$/.test(tel3)) {
        return false;
    }

    // Concatenate the parameters
    const concatenatedNumber = tel1 + tel2 + tel3;

    // Check if the length of the concatenated number is between 10 and 12
    if (concatenatedNumber.length >= 10 && concatenatedNumber.length <= 12) {
        return true;
    }

    return false;
}

function validateMobilePhoneNumber(tel1, tel2, tel3) {
    // Check if tel1 is a number and has a maximum length of 3
    if (!/^\d{3}$/.test(tel1)) {
        return false;
    }

    // Check if tel2 is a number and has a maximum length of 4
    if (!/^\d{4}$/.test(tel2)) {
        return false;
    }

    // Check if tel3 is a number and has a maximum length of 4
    if (!/^\d{4}$/.test(tel3)) {
        return false;
    }

    return true;
}

export { validatePhoneNumber, validateMobilePhoneNumber };
